import { connect } from 'react-redux';
import bridge from '@/utils/bridge';
import { SIDEBAR_CATEGORY } from '@/utils/customApps';
import appListHOC from '@/subscribeHOCs/appList';
import Sidebar from '../components/Sidebar';

const SESSION_ORDER_KEY = SIDEBAR_CATEGORY;
const SORTABLE_STORE = 'sortable_store';
const SIDEBAR_STATE_STORE = 'general_store';
const IS_CLOSED = 'isclosedapp';
const SIDEBAR_ARGS = 'sidebar_arguments';

/* Actions */
function getAppsOrder(sessionId) {
  return bridge
    .ask('Storage', 'get', [
      SORTABLE_STORE,
      `${SESSION_ORDER_KEY}_${sessionId}`,
    ])
    .then(response => {
      return response && response.split('|');
    });
}

const getSidebarState = sessionId => {
  return bridge
    .ask('Storage', 'get', [
      SIDEBAR_STATE_STORE,
      `sidebarStateStore_${IS_CLOSED}_${sessionId}`,
    ])
    .then((closed = 'true') => {
      const isClosed = closed && JSON.parse(closed);
      if (!isClosed) {
        return bridge
          .ask('Storage', 'get', [
            SIDEBAR_STATE_STORE,
            `sidebarStateStore_${SIDEBAR_ARGS}_${sessionId}`,
          ])
          .then(app => {
            console.log('appInfo', app);
            return JSON.parse(app);
          });
      }
      return false;
    });
};

const mapStateToProps = state => {
  const {
    _session: {
      current_session_meta_proxy: currentSessionId,
      currentOwnerGuid,
      session_proxy: sessionProxy,
    },
  } = state.restricted;

  const {
    dike: { [currentOwnerGuid]: { badges = [], appsOrder = [] } = {} },
  } = state.restricted;
  return {
    currentSessionId,
    badges: badges.map(b => b.appId),
    appsOrder,
    // filtered appList will come in props from appListHOC
    session: sessionProxy && sessionProxy[currentSessionId],
  };
};

function saveAppsOrder(sessionId, orderedAppIds) {
  const ownerGuid = sessionId.match(/session_(.*)@go.to/)[1];
  return dispatch => {
    dispatch({
      type: 'APPS_ORDER',
      payload: orderedAppIds,
      ownerGuid,
    });
  };
}

/**
 * Dispatch action creators to props of component
 * @param {function} dispatch
 * Always implement the following action creators:
 * init - listen to subscribers, some setup etc.
 */
const mapDispatchToProps = dispatch => ({
  /* Whenever a session is updated */
  async onCurrentSessionChange(currentSessionId) {
    /**
     * Get the order of apps from IndexedDB.
     * Reasons this is in props of Sidebar instead of state:
     * 1. Best place to make API calls is actions
     * 2. We need to get the order of apps every time session is updated, which is this method
     */
    if (currentSessionId) {
      dispatch(
        saveAppsOrder(currentSessionId, await getAppsOrder(currentSessionId))
      );
    }
  },
  getSidebarState,
  /**
   * Save the apps after drag and drop into the indexedDB and redux store
   * @param {string} sessionId The current sessionId of team
   * @param {*} orderedAppIds The latest order of the apps after drag and drop
   */
  saveAppsOrder(sessionId, orderedAppIds) {
    dispatch(saveAppsOrder(sessionId, orderedAppIds));
  },
  setSidebarState(sessionId, isClosed, app) {
    bridge.tell('Storage', 'set', [
      SIDEBAR_STATE_STORE,
      `sidebarStateStore_${IS_CLOSED}_${sessionId}`,
      JSON.stringify(isClosed),
    ]);
    if (!isClosed) {
      bridge.tell('Storage', 'set', [
        SIDEBAR_STATE_STORE,
        `sidebarStateStore_${SIDEBAR_ARGS}_${sessionId}`,
        JSON.stringify(app),
      ]);
    }
  },
});

export default appListHOC(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Sidebar),
  SIDEBAR_CATEGORY
);



// WEBPACK FOOTER //
// ./src/containers/SidebarContainer.js